import React, { forwardRef } from 'react'
import { tv } from 'tailwind-variants'

// Input's look for a field of more than one line: the same quiet border, field background, 13px text and blue
// focus ring, at a panel's 6px corners, and never resized by hand (a caller grows it to its text where it should).
// data-slot takes it out of style.scss's rules for bare fields, so these classes apply.
const textarea = tv({
  base: [
    'box-border block w-full resize-none rounded-md border border-divider bg-field px-3 py-1.5',
    '[font-family:inherit] text-[13px] leading-5 text-body placeholder:text-faint outline-none',
    'hover:border-faint focus:border-blue focus:ring-3 focus:ring-blue/15'
  ]
})

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => (
  <textarea ref={ref} data-slot="textarea" className={textarea({ class: className })} {...props} />
))

Textarea.displayName = 'Textarea'

export default Textarea
